"use client";

import { createContext, useContext } from "react";

const ConfigContext = createContext(null);

export function ConfigProvider({ config, children }: { config: any, children: React.ReactNode }) {
  return (
    <ConfigContext.Provider value={config}>
      {children}
    </ConfigContext.Provider>
  );
}

export function useConfig() {
  const config = useContext(ConfigContext);
  if (!config) throw new Error("useConfig must be used within ConfigProvider");
  return config;
}